<script setup lang="ts">

import FleetList from '@/components/Sections/Command/Fleets/FleetList.vue'
import { useRoute } from 'vue-router'
import { onMounted } from 'vue'
import router from '@/router'
import { useFleetStore } from '@/stores/fleetStore.ts'
import { useTableStore } from '@/stores/tableStore.ts'

const route = useRoute();
const fleetStore = useFleetStore()
const tableStore = useTableStore()


onMounted(() => {
  if(Number(route.params.fleetId) > 0) {
    // Load planet details from URL
    tableStore.fleets.singleSelectedId = Number(route.params.fleetId);
  } else if(tableStore.fleets.singleSelectedId > 0) {
    // Load from last selected planet
    //only when we are on portrait mode mobile
    if (window.innerWidth > 500) {
      router.push('/command/fleets/' + tableStore.fleets.singleSelectedId);
    }
  } else {
    // Load first planet from list
    if (fleetStore.fleets.size > 0 && window.innerWidth > 500) {
      router.push('/command/fleets/' + fleetStore.fleets.values().next().value.id);
    }
  }
});

</script>

<template>
  <div class="content-height-limit-tab overflow-y-hidden">
      <div class="flex flex-col md:flex-row">
        <div
          :class="{
          'w-full md:w-1/2' : true,
          'hidden sm:block' : Number(route.params.fleetId) > 0
        }">
          <div class="mt-2 mb-1 md:pr-2 pl-2">
            <FleetList/>
          </div>
        </div>
        <div class="w-full md:w-1/2  p-2 md:ps-0">
          <div class="rounded text-white">
            <router-view/>
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped lang="scss">

</style>